
import users from '@/services/users';

export default {
  data() {
    return {
      username: '',
      password: '',
      host: '',
      port: '',
      companyId: '',
      apiSecret: '',
      showPassword: false,
      showApiSecret: false,
      visible: false
    };
  },
  mounted() {
    this.getUserDetails();
  },
  methods: {
    async getUserDetails() {
      this.visible = true;
      try {
        const response = await users.getUserDetails();
        const details = response.data.response.userDetails;
        console.log('details', details);
        // Fill values from API
        this.username = details?.tenant?.flowFTP?.username || '';
        this.password = details?.tenant?.flowFTP?.password || '';
        this.host = details?.tenant?.flowFTP?.domain || '-';
        this.port = details?.tenant?.flowFTP?.sftpPort || details?.tenant?.flowFTP?.ftpPort;
        this.companyId = details?.tenant?._id || '';
        this.apiSecret = details?.tenant?.apiKey || '';
      } catch (e) {
        this.$q.notify({
          type: 'negative',
          message: 'Failed to load user details'
        });
      } finally {
        this.visible = false;
      }
    },

    async copyToClipboard(value) {
      if (!value) return;

      try {
        await navigator.clipboard?.writeText(value);
        this.$q.notify({
          type: 'positive',
          message: `${value} ${this.$store.state.user.translate.has_been_copied}`
        });
      } catch (e) {
        this.$q.notify({
          type: 'negative',
          message: 'Could not copy. Please try again.'
        });
      }
    }
  }
};
